import request from '../utils/request';
//登录
export function doLogin(data) {
  return request({
    url: 'user/login.html',
    method: 'post',
    data
  })
}

//考试列表
export function toExamQuize(data) {
  return request({
    url: 'userQuiz/toExamQuize.do',
    method: 'post',
    data
  })
}

//试卷记录
export function toExamUQDetail(data) {
  return request({
    url: 'userQuiz/toExamUQDetail.do',
    method: 'post',
    data
  })
}

//回显试卷
export function toPreview(data) {
  return request({
    url: 'userQuiz/toPreview.do',
    method: 'post',
    data
  })
}

//获取题目
export function toJoinExam(data) {
  return request({
    //url: 'userQuiz/toJoinExam.do',
    url: 'userQuiz/toJoinExamTest2.do',
    method: 'post',
    data
  })
}

//提交试卷
export function handInNew(data) {
  return request({
    url: 'userQuiz/handInNew.do',
    method: 'post',
    data
  })
}

//提交试卷之前
export function beforeHandInNew(data) {
  return request({
    url: 'userQuiz/beforeHandInNew.do',
    method: 'post',
    data
  })
}


//保存用户选择答案
export function handIn(data) {
  return request({
    url: 'userQuiz/handIn.do',
    method: 'post',
    data
  })
}

//签到
export function doSign(data) {
  return request({
    url: 'userQuiz/doSign',
    method: 'post',
    data
  })
}


//人脸识别
export function compareAndSavePhoto(data) {
  return request({
    url: 'user/compareAndSavePhoto.do',
    method: 'post',
    data
  })
}

//获取用户考试状态
export function findUQDetailState(data) {
  return request({
    url: 'userQuiz/findUQDetailState.do',
    method: 'post',
    data
  })
}

//获取用户是否能考试
export function findUQState(data) {
  return request({
    url: 'userQuiz/findUQState.do',
    method: 'post',
    data
  })
}

//退出登录
export function logout(data) {
  return request({
    url: 'logout',
    method: 'post',
    data
  })
}

//模拟考试列表
export function mockList() {
  return request({
    url: '/resource/code/mockList',
    method: 'get',
  })
}

//模拟考试详情
export function examQuizList(query) {
  return request({
    url: '/userQuiz/mockList',
    method: 'get',
    params:query
  })
}

//模拟考试实体
export function toJoinMockExam(data) {
  return request({
    url: '/userQuiz/toJoinMockExam.do',
    method: 'post',
    data
  })
}


//新逻辑考题
export function toJoinMockExamPhone( data) {
  return request({
    url: '/userQuiz/toJoinMockExamPhone.do',
    method: 'post',
     data
  })
}

//获取刷题平台名称
export function getName() {
  return request({
    url: '/resource/code/name.html',
    method: 'get',
  })
}

//记录断点
export function toRecordMockExam( data) {
  return request({
    url: '/userQuiz/toRecordMockExam.do',
    method: 'post',
     data
  })
}
